export interface IsEmpty {
  isEmpty: boolean;
}
